import { createSlice } from "@reduxjs/toolkit";
import { loginUserSelectInstitution, logoutUser } from "../actions/account";

const initialState = {
    tableFilters: {},
    columnFilters: [],
    rowsPerPage: 30,
    selectedFilter: null,
};

const constructionMatrixUISlice = createSlice({
    name: "constructionMatrixUI",
    initialState,
    reducers: {
        storeConstructionMatrixFilters(state, action) {
            state.tableFilters = action.payload;
        },
        storeConstructionMatrixColumnFilters(state, action) {
            state.columnFilters = action.payload;
        },
        setConstructionMatrixRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setConstructionMatrixSelectedFilter(state, action) {
            state.selectedFilter = action.payload;
        },
        resetConstructionMatrixUI() {
            return initialState;
        },
    },
    extraReducers: {
        [logoutUser.fulfilled]: () => initialState,
        [logoutUser.rejected]: () => initialState,
        [loginUserSelectInstitution.fulfilled]: () => initialState,
        [loginUserSelectInstitution.rejected]: () => initialState,
    },
});

export const getConstructionMatrixTableFilters = (state) => state.constructionMatrixUI.tableFilters;
export const getConstructionMatrixColumnFilters = (state) => state.constructionMatrixUI.columnFilters;
export const getConstructionMatrixRowsPerPage = (state) => state.constructionMatrixUI.rowsPerPage;
export const getConstructionMatrixSelectedFilter = (state) => state.constructionMatrixUI.selectedFilter;

export const { storeConstructionMatrixFilters, storeConstructionMatrixColumnFilters, setConstructionMatrixRowsPerPage, setConstructionMatrixSelectedFilter, resetConstructionMatrixUI } = constructionMatrixUISlice.actions;

export default constructionMatrixUISlice;